// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__4WQia","clinicsSelect":"TableHeading_clinicsSelect__2WURn"};